import React from 'react';
import { Table, Spinner } from 'reactstrap';
import { formatAmountWithCommas } from '../../../utils/number.util';

import './OutstandingTable.scss';

export default function OutstandingTable({ outstanding = [], isLoading }) {
  const getTotal = () => {
    const total = outstanding.reduce((sum, item) => {
      const amt = parseFloat(item?.amount || item?.Amount || 0);
      return sum + (Number.isNaN(amt) ? 0 : amt);
    }, 0);

    // Format with comma & 2 decimals
    return total.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const renderOutstanding = () => {
    if (isLoading) {
      return (
        <tr>
          <td colSpan="4" className="text-center py-2">
            <Spinner size="sm" color="primary" /> Loading...
          </td>
        </tr>
      );
    }

    if (!Array.isArray(outstanding) || outstanding.length === 0) {
      return (
        <tr>
          <td colSpan="3" className="text-center py-2">
            No outstanding loans available.
          </td>
        </tr>
      );
    }

    return outstanding.map((item, index) => (
      <tr key={item.id || index}>
        <td className="py-2 px-3">{item.loanType || item['Loan Type']}</td>
        <td className="py-2">{item.installments || item.Installments}</td>
        <td className="py-2 text-end">
          {formatAmountWithCommas(item.amount || item.Amount || 0)}
        </td>
      </tr>
    ));
  };

  return (
    <div className="loan-attachment-table-outer">
      <Table className="loan-attachment-table">
        <thead className="">
          <tr>
            <th className="py-2 fw-semibold px-3">Loan Type</th>
            <th className="py-2 fw-semibold">Deduction Period</th>
            <th className="py-2 fw-semibold text-end">Amount</th>
          </tr>
        </thead>
        <tbody>{renderOutstanding()}</tbody>
        <div className="d-flex justify-content-end mt-2 mb-2 fw-semibold total-loan-container">
          <span className="me-5 fs-6">Total : </span>
          <span className="fs-6 total-loan">{getTotal()}</span>
        </div>
      </Table>
    </div>
  );
}
